<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">


        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("warehouse_system_code_detail") }}</h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseExample" 
                    aria-expanded="false" 
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                      <p class="text-muted">{{this.forms.create_by}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{this.forms.created_at}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{this.forms.update_by}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{this.forms.updated_at}}</p>
                    </div>

                    
                    
                  </div>

                </div>

                <div class="card-body">

       
                  <form
                    class="forms-sample"
                    method="POST"
                  >
                    

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("company_group_id")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="company_group_id"
                          :placeholder="$t('company_group_id')"
                          v-model="forms.company_group.company_group_description"
                          readonly
                        />
                        <div v-if="errors.company_group_id">
                          <div
                            v-for="error in errors.company_group_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("customer")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <div v-if="this.forms.customer">
                        <input
                          type="text"
                          class="form-control"
                          id="customer"
                          :placeholder="$t('customer')"
                          v-model="forms.customer.customer_code"
                          readonly
                        />
                        </div><div v-else>
                        <input
                          type="text"
                          class="form-control"
                          id="customer"
                          :placeholder="$t('customer')"
                          readonly
                        />
                        </div>
                        <div v-if="errors.customer_id">
                          <div
                            v-for="error in errors.customer_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("fulfillment")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <div v-if="this.forms.fulfillment">
                        <input
                          type="text"
                          class="form-control"
                          id="fulfillment_id"
                          :placeholder="$t('fulfillment')"
                          v-model="forms.fulfillment.fulfillment_code"
                          readonly
                        />
                        </div><div v-else>
                        <input
                          type="text"
                          class="form-control"
                          id="customer"
                          :placeholder="$t('customer')"
                          readonly
                        />
                        </div>
                        <div v-if="errors.fulfillment_id">
                          <div
                            v-for="error in errors.fulfillment_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    
                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('category')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="category"
                          :placeholder="$t('category')"
                          v-model="forms.category"
                          readonly
                        />
                        <div v-if="errors.category">
                          <div
                            v-for="error in errors.category"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('code_type')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="code_type"
                        :placeholder="$t('code_type')"
                        v-model="forms.code_type"
                        readonly
                      />
                      <div v-if="errors.code_type">
                        <div
                          v-for="error in errors.code_type"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('code_id')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="code_id"
                        :placeholder="$t('code_id')"
                        v-model="forms.code_id"
                        readonly
                      />
                      <div v-if="errors.code_id">
                        <div
                          v-for="error in errors.code_id"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('code_description')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="code_description"
                        :placeholder="$t('code_description')"
                        v-model="forms.code_description"
                        readonly
                      />
                      <div v-if="errors.code_description">
                        <div
                          v-for="error in errors.code_description"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

    


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('outer_code')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="outer_code"
                        :placeholder="$t('outer_code')"
                        v-model="forms.outer_code"
                        readonly
                      />
                      <div v-if="errors.outer_code">
                        <div
                          v-for="error in errors.outer_code"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('show_sequence')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="show_sequence"
                        :placeholder="$t('show_sequence')"
                        v-model="forms.show_sequence"
                        readonly
                      />
                      <div v-if="errors.show_sequence">
                        <div
                          v-for="error in errors.show_sequence"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>
 
                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('active_flag')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="active_flag"
                        :placeholder="$t('active_flag')"
                        v-model="forms.active_flag"
                        readonly
                      />
                      <div v-if="errors.active_flag">
                        <div
                          v-for="error in errors.active_flag"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>
 
                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="default_flag" class="col-form-label" style="padding-left: 25px">{{
                        $t('default_flag')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="default_flag"
                        :placeholder="$t('default_flag')"
                        v-model="forms.default_flag"
                        readonly
                      />
                      <div v-if="errors.default_flag">
                        <div
                          v-for="error in errors.default_flag"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="udf01" class="col-form-label" style="padding-left: 25px">{{
                        $t('udf01')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="udf01"
                        :placeholder="$t('udf01')"
                        v-model="forms.udf01"
                        readonly
                      />
                      <div v-if="errors.udf01">
                        <div
                          v-for="error in errors.udf01"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="udf02" class="col-form-label" style="padding-left: 25px">{{
                        $t('udf02')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="udf02"
                        :placeholder="$t('udf02')"
                        v-model="forms.udf02"
                        readonly
                      />
                      <div v-if="errors.udf02">
                        <div
                          v-for="error in errors.udf02"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="udf03" class="col-form-label" style="padding-left: 25px">{{
                        $t('udf03')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="udf03"
                        :placeholder="$t('udf03')"
                        v-model="forms.udf03"
                        readonly
                      />
                      <div v-if="errors.udf03">
                        <div
                          v-for="error in errors.udf03"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="udf04" class="col-form-label" style="padding-left: 25px">{{
                        $t('udf04')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="udf04"
                        :placeholder="$t('udf04')"
                        v-model="forms.udf04"
                        readonly
                      />
                      <div v-if="errors.udf04">
                        <div
                          v-for="error in errors.udf04"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="udf05" class="col-form-label" style="padding-left: 25px">{{
                        $t('udf05')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="udf05"
                        :placeholder="$t('udf05')"
                        v-model="forms.udf05"
                        readonly
                      />
                      <div v-if="errors.udf05">
                        <div
                          v-for="error in errors.udf05"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc01" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c01')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc01"
                        :placeholder="$t('wsc01')"
                        v-model="forms.wsc01"
                        readonly
                      />
                      <div v-if="errors.wsc01">
                        <div
                          v-for="error in errors.wsc01"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc02" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c02')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc02"
                        :placeholder="$t('wsc02')"
                        v-model="forms.wsc02"
                        readonly
                      />
                      <div v-if="errors.wsc02">
                        <div
                          v-for="error in errors.wsc02"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc03" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c03')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc03"
                        :placeholder="$t('wsc03')"
                        v-model="forms.wsc03"
                        readonly
                      />
                      <div v-if="errors.wsc03">
                        <div
                          v-for="error in errors.wsc03"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc04" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c04')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc04"
                        :placeholder="$t('wsc04')"
                        v-model="forms.wsc04"
                        readonly
                      />
                      <div v-if="errors.wsc04">
                        <div
                          v-for="error in errors.wsc04"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc05" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c05')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc05"
                        :placeholder="$t('wsc05')"
                        v-model="forms.wsc05"
                        readonly
                      />
                      <div v-if="errors.wsc05">
                        <div
                          v-for="error in errors.wsc05"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc06" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c06')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc06"
                        :placeholder="$t('wsc06')"
                        v-model="forms.wsc06"
                        readonly
                      />
                      <div v-if="errors.wsc06">
                        <div
                          v-for="error in errors.wsc06"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc07" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c07')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc07"
                        :placeholder="$t('wsc07')"
                        v-model="forms.wsc07"
                        readonly
                      />
                      <div v-if="errors.wsc07">
                        <div
                          v-for="error in errors.wsc07"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc08" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c08')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc08"
                        :placeholder="$t('wsc08')"
                        v-model="forms.wsc08"
                        readonly
                      />
                      <div v-if="errors.wsc08">
                        <div
                          v-for="error in errors.wsc08"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc09" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c09')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc09"
                        :placeholder="$t('wsc09')"
                        v-model="forms.wsc09"
                        readonly
                      />
                      <div v-if="errors.wsc09">
                        <div
                          v-for="error in errors.wsc09"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="wsc10" class="col-form-label" style="padding-left: 25px">{{
                        $t('billing_customer_c10')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="wsc10"
                        :placeholder="$t('wsc10')"
                        v-model="forms.wsc10"
                        readonly
                      />
                      <div v-if="errors.wsc10">
                        <div
                          v-for="error in errors.wsc10"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

 
   
                  <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_delete"
                        class="
                          btn btn-danger
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="deleteData()"
                      >
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("deleteMess") }}
                      </a>

                      <a
                        v-if="permision_role.method_update"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "WarehouseSystemCodeDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      companyName:"",
      forms: { warehouse_system_code_id: "", company_group_id: "" , customer_id:"", category:"", code_type:"", code_id:"", code_description:"", outer_code:"", show_sequence:0, active_flag:"", default_flag:"",  udf01:"", udf02:"", udf03:"", udf04:"", udf05:"", wsc01:"", wsc02:"", wsc03:"", wsc04:"", wsc05:"", wsc06:"", wsc07:"", wsc08:"", wsc09:"", wsc10:"", company_group:"", customer:"",fulfillment:""},

    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.company_group              = "";
      this.forms.warehouse_system_code_id   = "";
      this.forms.company_group_id           = "";
      this.forms.customer_id                = "";
      this.forms.fulfillment_id             = "";
      this.forms.fulfillment                = "";
      this.forms.category                   = "";
      this.forms.code_type                  = "";
      this.forms.code_id                    = "";
      this.forms.outer_code                 = "";
      this.forms.show_sequence              = 0;
      this.forms.active_flag                = "";
      this.forms.default_flag               = "";
      this.forms.udf01                      = "";
      this.forms.udf02                      = "";
      this.forms.udf03                      = "";
      this.forms.udf04                      = "";
      this.forms.udf05                      = "";
      this.forms.wsc01                      = "";
      this.forms.wsc02                      = "";
      this.forms.wsc03                      = "";
      this.forms.wsc04                      = "";
      this.forms.wsc05                      = "";
      this.forms.wsc06                      = "";
      this.forms.wsc07                      = "";
      this.forms.wsc08                      = "";
      this.forms.wsc09                      = "";
      this.forms.wsc10                      = "";
    },


    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/billing-warehouse-system-code/edit/" + params;
    },

    deleteData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI = this.$settings.endPointBilling + "dashboard/warehouse-system-code/delete/" + id;
          this.$http
            .delete(baseURI, formData,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/billing-warehouse-system-code";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
                this.loading();
                this.isLoading = false;
                  
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }else{
          this.isLoading = false;
        }
      });
    },

    backForm() {
      window.location.href = "/billing-warehouse-system-code";
    },

    loadData(id) {
      this.isLoading = true;

      const baseURI = this.$settings.endPointBilling + "dashboard/warehouse-system-code/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
       this.isLoading = false;
        this.forms = response.data.datas;

      }).catch(error => {
          this.isLoading = false;
           
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });
    },


      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },
    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BillingWarehouseSystemCodeController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },
 

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped>

</style>